import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
let DataAnalysisService = class DataAnalysisService {
    constructor(workspaceApi) {
        this.workspaceApi = workspaceApi;
    }
    async getWorkspaceSummary(data) {
        const res = await this.workspaceApi.getWorkspaceSummary(data);
        return res;
    }
};
DataAnalysisService = __decorate([
    injectable(),
    __param(0, inject(Symbols.WorkspaceApi)),
    __metadata("design:paramtypes", [Object])
], DataAnalysisService);
export { DataAnalysisService };
